const ArtemisFonts = text => ({
  fontFamily: text?.defaultFontStyle?.fontFamily,
  fontWeight: text?.defaultFontStyle?.fontWeight,
  fontSize: text?.largeDevice?.fontSize,
  letterSpacing: text?.largeDevice?.letterSpacing,
  textTransform: text?.textTransform,
});

export default ArtemisFonts;
